<template>
  <v-form @submit.prevent="submit">
    <v-layout row wrap>
      <v-flex xs12 :md6="readOnly">
        <v-text-field
          :class="['border-container', !nameErrors.length ? '' : 'border-red']"
          v-model="form.name"
          label="Nombre del horario"
          solo
          flat
          required
          @input="$v.form.name.$touch()"
          @blur="$v.form.name.$touch()"
          :error-messages="nameErrors"
          hide-details
          :disabled="readOnly"
        />
      </v-flex>
      <v-flex xs12> El horario aplica en los días hábiles del colegio </v-flex>
      <v-flex xs12 md6>
        <div class="border-section pa-3">
          <v-layout>
            <v-flex xs6 :md3="readOnly"> Hora de entrada: </v-flex>
            <v-flex xs6>
              <v-layout align-center class="datepicker-container">
                <v-icon
                  :class="[
                    'clock-notice',
                    !startTimeErrors.length ? '' : 'red--text',
                  ]"
                >
                  schedule
                </v-icon>
                <vue-timepicker
                  class="pickers"
                  v-model="form.startTime"
                  full-width
                  drop-direction="auto"
                  format="hh:mm a"
                  header-color="primary"
                  manual-input
                  close-on-complete
                  :disabled="readOnly"
                  @close="validateTime"
                />
              </v-layout>
              <div
                class="v-text-field__details"
                v-if="!!startTimeErrors.length"
              >
                <div class="v-messages error--text">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ startTimeErrors[0] }}
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6 :md3="readOnly">Hora salida:</v-flex>
            <v-flex xs6>
              <v-layout align-center class="datepicker-container">
                <v-icon
                  :class="[
                    'clock-notice',
                    !endTimeErrors.length ? '' : 'red--text',
                  ]"
                >
                  schedule
                </v-icon>
                <vue-timepicker
                  class="pickers"
                  v-model="form.endTime"
                  full-width
                  drop-direction="auto"
                  format="hh:mm a"
                  header-color="primary"
                  manual-input
                  close-on-complete
                  :disabled="readOnly"
                  @close="validateTime"
                />
              </v-layout>
              <div class="v-text-field__details" v-if="!!endTimeErrors.length">
                <div class="v-messages error--text">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ endTimeErrors[0] }}
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs12 md6>
        <div class="border-section pa-3">
          <v-layout row>
            <v-flex xs6 md8 :lg6="readOnly"
              >Acceso permitido antes de hora de ingreso:</v-flex
            >
            <v-flex xs5>
              <v-layout align-start class="datepicker-container">
                <v-icon
                  :class="[
                    'clock-notice',
                    !minutesEarlyErrors.length ? '' : 'red--text',
                  ]"
                >
                  schedule
                </v-icon>
                <vue-timepicker
                  class="pickers"
                  v-model="form.minutesEarly"
                  full-width
                  drop-direction="auto"
                  header-color="primary"
                  :minute-interval="5"
                  :hour-range="[[0, 5]]"
                  manual-input
                  close-on-complete
                  :disabled="readOnly"
                />
              </v-layout>
              <div
                class="v-text-field__details"
                v-if="!!minutesEarlyErrors.length"
              >
                <div class="v-messages error--text">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ minutesEarlyErrors[0] }}
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs6 md8 :lg6="readOnly"
              >Tolerancia después de la hora de ingreso:</v-flex
            >
            <v-flex xs5>
              <v-layout align-center class="datepicker-container">
                <v-icon
                  :class="[
                    'clock-notice',
                    !minutesLateErrors.length ? '' : 'red--text',
                  ]"
                >
                  schedule
                </v-icon>
                <vue-timepicker
                  class="pickers"
                  v-model="form.minutesLate"
                  full-width
                  drop-direction="auto"
                  :minute-interval="5"
                  :hour-range="[[0, 5]]"
                  header-color="primary"
                  manual-input
                  close-on-complete
                  :disabled="readOnly"
                />
              </v-layout>
              <div
                class="v-text-field__details"
                v-if="!!minutesLateErrors.length"
              >
                <div class="v-messages error--text">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message">
                      {{ minutesLateErrors[0] }}
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12>
        Colaboradores<br />
        <p v-if="!readOnly" style="color: rgba(0, 0, 0, 0.54)">
          Selecciona los colaboradores que quieras a este horario de la tabla
          derecha.
        </p>
        <div
          :class="[
            'colab-container',
            'border-container',
            !collaboratorIdsErrors.length ? '' : 'border-red',
          ]"
        >
          <v-chip
            v-for="i in form.collaboratorIds"
            :key="i.id"
            :close="!readOnly"
            color="#fbdfde"
            style="color: #b91b19"
            @input="removeCollaborator(i)"
          >
            <strong>{{ i.firstName }} {{ i.lastName }}</strong>
          </v-chip>
        </div>
      </v-flex>
    </v-layout>
    <!-- <v-layout justify-end row class="py-3" v-if="!readOnly">
      <v-btn @click="confirmCancelModal = true">Cancelar</v-btn>
      <v-btn type="submit" color="#ef565c" style="color: #fff"> Guardar </v-btn>
    </v-layout> -->
    <Confirm
      :value="confirmCancelModal"
      title="Cancelar"
      :description="onCancelAlertMsg"
      @desition="confirmCancel"
    />
  </v-form>
</template>

<script>
import moment from 'moment'
import VueTimepicker from 'vue2-timepicker'
import { minLength, required } from 'vuelidate/lib/validators'
import Confirm from '../../Dialogs/Cancel.vue'
// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  components: {
    VueTimepicker,
    Confirm,
  },
  props: {
    initialValues: {
      type: Object,
      default: () => ({
        collaboratorIds: [],
        type: 'FULL_TIME',
        name: '',
        startTime: '',
        endTime: '',
        minutesEarly: '',
        minutesLate: '',
      }),
    },
    selected: { type: Array, default: () => [] },
    readOnly: { type: Boolean, default: false },
    onCancelAlertMsg: {
      type: String,
      default: '¿Estas seguro que deseas cancelar?',
    },
  },
  validations: {
    form: {
      name: {
        required,
      },
      startTime: {
        required,
        isValid(value) {
          return moment(value, 'hh:mm a', true).isValid()
        },
        isBeforeEnd(value, { endTime }) {
          if (value && endTime) {
            const endHour = moment(endTime, 'hh:mm a', true)
            const startHour = moment(value, 'hh:mm a', true)
            if (startHour.isValid() && endHour.isValid()) {
              return startHour.isBefore(endHour)
            }
            return true
          }
          return true
        },
      },
      endTime: {
        required,
        isValid(value) {
          return moment(value, 'hh:mm a', true).isValid()
        },
        isAfterStart(value, { startTime }) {
          if (value && startTime) {
            const endHour = moment(value, 'hh:mm a', true)
            const startHour = moment(startTime, 'hh:mm a', true)
            if (startHour.isValid() && endHour.isValid()) {
              return endHour.isAfter(startHour)
            }
            return true
          }
          return true
        },
      },
      minutesEarly: {
        required,
        hourValidation(value) {
          return moment(value, 'HH:mm', true).isValid()
        },
      },
      minutesLate: {
        required,
        hourValidation(value) {
          return moment(value, 'HH:mm', true).isValid()
        },
      },
      collaboratorIds: {
        required,
        minLength: minLength(1),
      },
    },
  },
  data() {
    return {
      form: this.initialValues,
      confirmCancelModal: false,
      firstClose: true,
    }
  },
  methods: {
    openCancelModal() {
      this.confirmCancelModal = true
    },
    confirmCancel(desition) {
      if (desition) {
        this.reset()
      }
      this.confirmCancelModal = !this.confirmCancelModal
    },
    removeCollaborator(c) {
      this.$emit('onDeleteSelected', c)
    },
    validateTime() {
      if (this.firstClose) {
        this.$v.form.startTime.$touch()
        this.$v.form.endTime.$touch()
        this.firstClose = false
      }
    },
    reset() {
      this.$v.$reset()
      this.form = {
        collaboratorIds: [],
        type: 'FULL_TIME',
        name: '',
        startTime: 'hh:mm a',
        endTime: 'hh:mm a',
        minutesEarly: 'HH:mm',
        minutesLate: 'HH:mm',
      }
      this.$emit('onCancel')
    },
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        console.error('fail to submil', this.$v)
      } else {
        this.wUpdate = true
        const {
          startTime,
          endTime,
          minutesEarly,
          minutesLate,
          type,
          name,
          collaboratorIds,
        } = this.form
        const values = {
          type,
          collaboratorIds: collaboratorIds.map((c) => c.id),
          name,
          startTime: moment(startTime, 'hh:mm a').format('HH:mm:ss'), // 24 hours format
          endTime: moment(endTime, 'hh:mm a').format('HH:mm:ss'), // 24 hours format
          minutesEarly: moment
            .duration(moment(minutesEarly, 'HH:mm').format('HH:mm'))
            .asMinutes(),
          minutesLate: moment
            .duration(moment(minutesLate, 'HH:mm').format('HH:mm'))
            .asMinutes(),
        }
        this.$emit('onSubmit', values)
      }
    },
  },
  watch: {
    selected() {
      this.form.collaboratorIds = this.selected
    },
    initialValues() {
      if (this.initialValues !== null) {
        this.form = {
          ...this.initialValues,
        }
      }
    },
    form: {
      handler() {
        this.$emit('form', this.form)
      },
      deep: true,
    },
  },

  computed: {
    nameErrors() {
      const errors = []
      if (!this.$v.form.name.$dirty) return errors
      !this.$v.form.name.required && errors.push('Requerido')
      return errors
    },
    startTimeErrors() {
      const errors = []
      if (!this.$v.form.startTime.$dirty) return errors
      !this.$v.form.startTime.required && errors.push('Requerido')
      !this.$v.form.startTime.isValid &&
        errors.push('Formato de horario inválido')
      !this.$v.form.startTime.isBeforeEnd &&
        errors.push('La hora de entrada debe ser anterior a la hora de salida')
      return errors
    },
    endTimeErrors() {
      const errors = []
      if (!this.$v.form.endTime.$dirty) return errors
      !this.$v.form.endTime.required && errors.push('Requerido')
      !this.$v.form.endTime.isValid &&
        errors.push('Formato de horario inválido')
      !this.$v.form.endTime.isAfterStart &&
        errors.push('La hora de salida debe ser posterior a la hora de entrada')
      return errors
    },
    minutesEarlyErrors() {
      const errors = []
      if (!this.$v.form.minutesEarly.$dirty) return errors
      !this.$v.form.minutesEarly.required && errors.push('Requerido')
      !this.$v.form.minutesEarly.hourValidation &&
        errors.push('Formato de horario inválido')
      return errors
    },
    minutesLateErrors() {
      const errors = []
      if (!this.$v.form.minutesLate.$dirty) return errors
      !this.$v.form.minutesLate.required && errors.push('Requerido')
      !this.$v.form.minutesLate.hourValidation &&
        errors.push('Formato de horario inválido')
      return errors
    },
    collaboratorIdsErrors() {
      const errors = []
      if (!this.$v.form.collaboratorIds.$dirty) return errors
      !this.$v.form.collaboratorIds.required && errors.push('Requerido')
      !this.$v.form.collaboratorIds.minLength &&
        errors.push('Al menos 1 colaborador debe ser seleccionado')
      return errors
    },
  },
}
</script>

<style scoped>
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}
.border-section {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
}
.border-red {
  border-color: red !important;
}
.datepicker-border {
  border: 2px solid #757575;
}
.datepicker-container {
  padding: 5px;
}
.colab-container {
  min-height: 82px;
}
</style>
